export type CommonColors = typeof commonColors;

export const commonColors = {
  /* Colors (Light Theme) */
  white: "var(--hv-white)",
  black: "var(--hv-black)",
  surface: "var(--hv-surface)",
  surfaceWidget: "var(--hv-surface-widget)",
  surfacePopup: "var(--hv-surface-popup)",
  surfacePopupPanel: "var(--hv-surface-popup-panel)",

  /* Interaction */
  interactionHover: "var(--hv-interaction-hover)",
  interactionPress: "var(--hv-interaction-press)",
  interactionSelectGray: "var(--hv-interaction-select-gray)",
  interactionSelectOrange: "var(--hv-interaction-select-orange)",

  /* Brand */
  brandPrimary: "var(--hv-brand-primary)",

  /* Data */
  dataBlue: "var(--hv-data-blue)",
  dataRed: "var(--hv-data-red)",
  dataGray: "var(--hv-data-gray)",
  dataGreen: "var(--hv-data-green)",
  dataYellow: "var(--hv-data-yellow)",
  dataSapphire: "var(--hv-data-sapphire)",
  dataOrange: "var(--hv-data-orange)",
  dataEmerald: "var(--hv-data-emerald)",
  dataCoral: "var(--hv-data-coral)",
  dataIndigo: "var(--hv-data-indigo)",
  dataPurple: "var(--hv-data-purple)",
  dataViolet: "var(--hv-data-violet)",
  dataPink: "var(--hv-data-pink)",

  /* Primary Button */
  buttonPrimaryDefault: "var(--hv-button-primary-default)",
  buttonPrimaryHover: "var(--hv-button-primary-hover)",
  buttonPrimaryPress: "var(--hv-button-primary-press)",
  buttonPrimaryDisabled: "var(--hv-button-primary-disabled)",

  /* Secondary Button */
  buttonSecondaryDefault: "var(--hv-button-secondary-default)",
  buttonSecondaryHover: "var(--hv-button-secondary-hover)",
  buttonSecondaryPress: "var(--hv-button-secondary-press)",
  buttonSecondaryDisabled: "var(--hv-button-secondary-disabled)",

  /* Tertiary Button */
  buttonTertiaryHover: "var(--hv-button-tertiary-hover)",
  buttonTertiaryPress: "var(--hv-button-tertiary-press)",
  buttonTertiaryOutlineDefault: "var(--hv-button-tertiary-outline-default)",

  /* Ghost Button */
  buttonGhostHover: "var(--hv-button-ghost-hover)",
  buttonGhostPress: "var(--hv-button-ghost-press)",
  buttonGhostDisabled: "var(--hv-button-ghost-disabled)",

  /* Normal Icon */
  iconNormalPrimary: "var(--hv-icon-normal-primary)",
  iconNormalSecondary: "var(--hv-icon-normal-secondary)",
  iconNormalTertiary: "var(--hv-icon-normal-tertiary)",
  iconNormalDisabled: "var(--hv-icon-normal-disabled)",

  /* On-Brand Icon */
  iconOnBrandPrimary: "var(--hv-icon-on-brand-primary)",
  iconOnBrandSecondary: "var(--hv-icon-on-brand-secondary)",
  iconOnBrandTertiary: "var(--hv-icon-on-brand-tertiary)",
  iconOnBrandDisabled: "var(--hv-icon-on-brand-disabled)",

  /* Normal Text */
  textNormalPrimary: "var(--hv-text-normal-primary)",
  textNormalSecondary: "var(--hv-text-normal-secondary)",
  textNormalTertiary: "var(--hv-text-normal-tertiary)",
  textNormalDisabled: "var(--hv-text-normal-disabled)",

  /* On-Brand Text */
  textOnBrandPrimary: "var(--hv-text-on-brand-primary)",
  textOnBrandSecondary: "var(--hv-text-on-brand-secondary)",
  textOnBrandTertiary: "var(--hv-text-on-brand-tertiary)",
  textOnBrandDisabled: "var(--hv-text-on-brand-disabled)",

  /* Input Foreground Colors */
  inputForegroundDefault: "var(--hv-input-foreground-default)",
  inputForegroundHover: "var(--hv-input-foreground-hover)",
  inputForegroundPress: "var(--hv-input-foreground-press)",
  inputForegroundDisabled: "var(--hv-input-foreground-disabled)",

  /* Input Outline Colors */
  inputOutlineActive: "var(--hv-input-outline-active)",
  inputOutlineDefault: "var(--hv-input-outline-default)",
  inputOutlineHover: "var(--hv-input-outline-hover)",
  inputOutlinePress: "var(--hv-input-outline-press)",

  /* Border Colors */
  borderDefault: "var(--hv-border-default)",
  borderEmphasis: "var(--hv-border-emphasis)",

  /* Scroll Colors */
  scrollDefault: "var(--hv-scroll-default)",
  scrollHover: "var(--hv-scroll-hover)",

  /* Table Header Colors */
  tableHeaderDefault: "var(--hv-table-header-default)",

  /* Loading Colors */
  loadingCircuitRingDefault: "var(--hv-loading-circuit-ring-default)",
  loadingSpinnerPrimary: "var(--hv-loading-spinner-primary)",
  loadingSpinnerSecondary: "var(--hv-loading-spinner-secondary)",

  /* Alert Colors */
  alertTextDefault: "var(--hv-alert-text-default)",
  alertIconDefault: "var(--hv-alert-icon-default)",
  alertBackgroundDefault: "var(--hv-alert-background-default)",

  /* Snack Bar Colors */
  snackBarTextDefault: "var(--hv-snack-bar-text-default)",
  snackBarIconDefault: "var(--hv-snack-bar-icon-default)",
  snackBarIconHover: "var(--hv-snack-bar-icon-hover)",
  snackBarIconPress: "var(--hv-snack-bar-icon-press)",
  snackBarBackgroundDefault: "var(--hv-snack-bar-background-default)",

  /* Tooltip Colors */
  tooltipBackground: "var(--hv-tooltip-background)",

  /* Dropdown Colors */
  optionsBackgoundColor: "var(--hv-options-backgound-color)",
  optionsBorderColor: "var(--hv-options-border-color)",

  /* Avatar Colors */
  avatarBackgroundPrimaryTop: "var(--hv-avatar-background-primary-top)",
  avatarBackgroundPrimaryBottom: "var(--hv-avatar-background-primary-bottom)",
  avatarBackgroundSecondaryTop: "var(--hv-avatar-background-secondary-top)",
  avatarBackgroundSecondaryBottom:
    "var(--hv-avatar-background-secondary-bottom)",
  avatarTextPrimary: "var(--hv-avatar-text-primary)",
  avatarTextSecondary: "var(--hv-avatar-text-secondary)",

  /* Toggle Colors */
  toggleDefault: "var(--hv-toggle-default)",
  toggleSelectedGreen: "var(--hv-toggle-selected-green)",
  toggleSelectedOrange: "var(--hv-toggle-selected-orange)",
  toggleDisabled: "var(--hv-toggle-disabled)",
  toggleHandle: "var(--hv-toggle-handle)",

  /* PI Logo Colors */
  piLogoOrange: "var(--hv-pi-logo-orange)",
  piLogoIntersection: "var(--hv-pi-logo-intersection)",
  piLogoGray: "var(--hv-pi-logo-gray)",
  piLogoLeft: "var(--hv-pi-logo-left)",
  piLogoIntersectionGray: "var(--hv-pi-logo-intersection-gray)",
  piLogoRight: "var(--hv-pi-logo-right)",
};
